import { Component, OnInit, AfterViewInit, EventEmitter, Output } from '@angular/core';
import { Http } from "@angular/http";
import { Router }  from '@angular/router';
import { Member } from '../member/member';
import { MemberService } from '../member/member.service';
import * as firebase from 'firebase';
import * as _ from 'underscore';
import { Angular2Csv } from 'angular2-csv/Angular2-csv';

import tinymce from 'tinymce/tinymce';
import 'tinymce/themes/modern/theme';
import 'tinymce/plugins/paste';
import 'tinymce/plugins/link';
import 'tinymce/plugins/textcolor';
import 'tinymce/plugins/autolink';
import 'tinymce/plugins/emoticons';
import 'tinymce/plugins/table';
import 'tinymce/plugins/image';
import 'tinymce/plugins/media';
import 'tinymce/plugins/imagetools';


/**
 * Modules
 */
import { AlertModule } from 'ng2-bootstrap';

//import {DataTableModule} from "angular2-datatable";

@Component({
  selector: 'cef-journey',
  templateUrl: './journey.component.html'
})

export class JourneyComponent implements OnInit {
	@Output() onEditorKeyup = new EventEmitter<any>();
	public existChapter = new Array();
	public currUser = {
		uid:'',
		email:'',
		level:'',
		unit:''
	};
	public ansList = ['A','B','C','D','E','F','G','H'];
	public allProfile;
	public searchableMem = new Array();
	public viewMem = new Array();
	public viewMemApproval = new Array();
	public selectedMem = new Array();
	public detailMem = '';
	public approvalDate = new Date().toISOString().slice(0,10);
	public qaImg = 0;
	public replyNum = '';
	public journeyRecs = {};
	public msgTo = '';
	public msgTitle = '';
	public msgContent = '';
	public warningMsg = '';
	public allApproveSelected = false;
	public currTab = 0;
	public contentMsg = {};
	public selectedJourney = 0;
	public totalJourney = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27]

	public filterQuery = "";
	public groupQuery = "";
    public rowsOnPage = 15;
    public sortBy = "sendDate";
    public sortOrder = "desc";

	public chapterThumb = new Array();
	public s3ChapterParams = {
		Bucket: 'cefkid-journey',
		Delimiter: '/'
	};

	editor;

 	constructor(private http: Http, private router: Router, private memberService: MemberService) {
		
	}

	ngAfterViewInit() {
		tinymce.init({
		  selector: '#replyEditor',
		  plugins: ['link', 'paste', 'textcolor', 'autolink', 'emoticons', 'table','image', 'media', 'imagetools'],
		  skin_url: '../assets/skins/lightgray',
		  toolbar1: 'undo redo styleselect bold italic alignleft aligncenter alignright bullist numlist outdent indent code',
		  toolbar2: 'emoticons image media link paste forecolor backcolor',
		  paste_data_images: false, 
		  min_height: 200, 
		  setup: editor => {
		    this.editor = editor;
		    editor.on('keyup', () => {
		      const content = editor.getContent();
		      this.onEditorKeyup.emit(content);
		    });
		  },
		});
	}

	ngOnInit(): void {
		this.memberService.s3.listObjectsV2(this.s3ChapterParams, (err, data) => {
			if (!err) {
				if (data.CommonPrefixes.length) {
					for (var chapter of data.CommonPrefixes){
						var chapterName = chapter.Prefix.replace('/','');
						this.existChapter.push(chapterName.substr(7));
					}
				}
			} else {
				console.log(err);
			}
		});

		let db = firebase.database();

		firebase.auth().onAuthStateChanged((user:any) => {
		  if (user) {
		    this.currUser.uid = user.uid;
			//this.currUser.uid = 'ocHGuAMvMpWdj77lyPBf0k6d5bH2';
		    this.currUser.email = user.email;
		    db.ref('profile/'+this.currUser.uid).once('value').then(
				(snapshot:any) => {
					if (snapshot.val()){
						let returnVal = snapshot.val();
						this.currUser.level = returnVal.level;
						this.currUser.unit = returnVal.unit;
						this._findSearchable();
					}
				}
			)
		  }
		});	   
    }

    _findSearchable() {
    	let db = firebase.database();
    	//var allProfile;
    	
    	db.ref('profile/').once('value').then(
			(snapshot:any) => {
				if (snapshot.val()){
					this.allProfile = snapshot.val();
					if (this.currUser.level <= '2'){
						for (let uid in this.allProfile){
							if (this.allProfile[uid].level != '4') continue;
							if (this.currUser.level == '0' || this.currUser.level == '1'){
								//web admin and admin can manage all member
								this.searchableMem.push({uid:uid,name:this.allProfile[uid].name,level:this.allProfile[uid].level,unit:this.allProfile[uid].unit});
							} else if (this.currUser.level == '2'){
								//course admin can manage to same unit of member
								if (this.currUser.unit!=this.allProfile[uid].unit) continue;
								this.searchableMem.push({uid:uid,name:this.allProfile[uid].name,level:this.allProfile[uid].level,unit:this.allProfile[uid].unit});
							}
						}
						this.searchableMem = _.sortBy( this.searchableMem, 'unit' );
					} else if (this.currUser.level == '3'){
						//teacher can mange their member in charge
						db.ref('parentToChild/'+this.currUser.uid).once('value').then(
							(snapshot:any)=>{
								let returnVal = snapshot.val();
								for (let i in returnVal){
									this.searchableMem.push({
										uid:returnVal[i],
										name:this.allProfile[returnVal[i]].name,
										level:this.allProfile[returnVal[i]].level,
										unit:this.allProfile[returnVal[i]].unit
									});
								}
							}
						);
					}
					
									
				}
			}
		)
    }

	exportCSV(){
		var exportData=[];
		exportData.push(
			{name:"1",chapter:"神創造你，而且了解你，你可以怎樣多謝神？ ",q1:"A 用詩歌讚美祂",q2:"B 直接祈禱告訴祂",q3:"C 和其他人分享祂的好",q4:"D 返教會認識衪",q5:"E 其他：",q6:"F",q7:"G",q8:"H"},
			{name:"2",chapter:"以下都是神不喜歡的行為，你有犯過嗎？",q1:"A 發脾氣",q2:"B 說謊",q3:"C 妒忌",q4:"D 不認創造我們的神",q5:"E 其他：",q6:"F",q7:"G",q8:"H"},
			{name:"3",chapter:"耶穌代替你的罪受罰，你有何感受？",q1:"A 羞愧",q2:"B 難過",q3:"C 感恩",q4:"D 快樂",q5:"E 其他：",q6:"F",q7:"G",q8:"H"},
			{name:"4",chapter:"當你知道主耶穌為了代替你的罪受死，你會作出甚麼選擇呢？",q1:"A 我跟著博士祈禱，決志相信耶穌，讓耶穌做我的救主。",q2:"B 我希望導師教我祈禱，請耶穌做我的救主。",q3:"C 我從前已祈禱接受主耶穌，現在更感謝祂。",q4:"D 我希望知道更多耶穌的事。",q5:"E 我還有疑問，就是",q6:"F",q7:"G",q8:"H"},
			{name:"5",chapter:"你現在有了神的兒女這尊貴的身份，你有甚麼感受呢？",q1:"A 我好快樂！",q2:"B 我好想告訴別人！",q3:"C 我想做個天父喜歡的乖兒女！",q4:"D 我希望知道更多耶穌的事情。",q5:"E 其他：",q6:"F",q7:"G",q8:"H"},
			{name:"6",chapter:"神賜給信祂的人以下的福氣，你認為哪項對你最寶貴？ ",q1:"A 我的罪全部被赦免了！",q2:"B 我是神的兒女！",q3:"C 耶穌在我心裏，會隨時幫助我！",q4:"D 我有永生，可以進天堂！",q5:"E 其他：",q6:"F",q7:"G",q8:"H"},
			{name:"7",chapter:"假若別人反對或嘲笑你相信主耶穌，你會怎麼辦？",q1:"A 向導師傾訴難受的心情！",q2:"B 忍耐，請主耶穌幫助我有勇氣去面對！",q3:"C 不害怕，告訴他們相信耶穌是超級棒的事！",q4:"D 不會再告訴別人自己相信了耶穌！",q5:"E 其他：",q6:"F",q7:"G",q8:"H"},
			{name:"8",chapter:"主耶穌希望你的新生命能夠成長得更像祂！你認為哪些「成長的行動」較難做到？",q1:"A 看聖經，認識神的話！",q2:"B 多祈禱，與神談話！",q3:"C 返教會，和大家一齊敬拜神！",q4:"D 作見證，告訴別人耶穌是你的救主！",q5:"E 其他：",q6:"F",q7:"G",q8:"H"},
			{name:"9",chapter:"你認為我們向天父祈禱時，哪種態度最重要？",q1:"A 真心真意",q2:"B 低下頭",q3:"C 合十雙手",q4:"D 合上眼睛，專注禱告",q5:"E 其他：",q6:"F",q7:"G",q8:"H"},
			{name:"10",chapter:"神喜悅我們向祂禱告，哪一項是你最少向神訴說的呢？",q1:"A 讚美神",q2:"B 感謝神",q3:"C 向神承認生活上的惡行，求主赦免",q4:"D 為你關心的人代求",q5:"E 為自己的需要及困難祈求",q6:"F",q7:"G",q8:"H"},
			{name:"11",chapter:"愛你的神透過聖經向你說話，哪些項目是你想藉聖經明白的呢？ ",q1:"A 耶穌施行的救恩",q2:"B 天父指示你人生的方向",q3:"C 人類的歷史",q4:"D 有關神的事情",q5:"E 其他：",q6:"F",q7:"G",q8:"H"},
			{name:"12",chapter:"在你一日的生活中，哪一段時間最適合安靜靈修，讀聖經、祈禱親近神呢？",q1:"A 早上醒來",q2:"B 放學回家",q3:"C 完成功課後",q4:"D 睡覺前",q5:"E 其他：",q6:"F",q7:"G",q8:"H"},
			{name:"13",chapter:"神希望你能把祂的話記在心裏。你有可閱讀的聖經嗎？",q1:"A 我已擁有一本屬於自己的聖經",q2:"B 我計劃在佈道團的網站上讀聖經",q3:"C 我會向老師/導師借聖經",q4:"D 我會在圖書館借閱聖經",q5:"E 其他：",q6:"F",q7:"G",q8:"H"},
			{name:"14",chapter:"神喜悅基督徒聚在一起敬拜祂！有甚麼原因讓你難以返教會嗎？",q1:"A 沒有認識的教會可返",q2:"B 沒有朋友陪我",q3:"C 怕父母反對",q4:"D 功課忙，沒有時間",q5:"E 其他：",q6:"F",q7:"G",q8:"H"},
			{name:"15",chapter:"快樂的事要與人分享！耶穌愛你這好消息，你要與誰分享呢？",q1:"A 公公婆婆、爺爺嫲嫲",q2:"B 爸爸媽媽",q3:"C 好朋友",q4:"D 同學",q5:"E 其他：",q6:"F",q7:"G",q8:"H"},
			{name:"16",chapter:"愈親近神，你的生命愈像祂！你最渴望擁有哪種「屬靈果子」的特質呢？",q1:"A 喜樂",q2:"B 良善",q3:"C 忍耐",q4:"D 節制",q5:"E 其他：",q6:"F",q7:"G",q8:"H"},
			{name:"17",chapter:"每天求主看顧你一天的生活，並賜你能力拒絕做不正確的事。",q1:"A 每天都做得到",q2:"B 有幾天做得到",q3:"C 一天也沒有做到",q4:"D 我會繼續去做",q5:"E 請分享一件你拒絕去做的不正確事情",q6:"F",q7:"G",q8:"H"},
			{name:"18",chapter:"睡覺前，把心事告訴天父，也為你掛心的家人及朋友代禱。",q1:"A 每天都做得到",q2:"B 有幾天做得到",q3:"C 一天也沒有做到",q4:"D 我會繼續去做",q5:"E 請分享一件令你擔心的事情",q6:"F",q7:"G",q8:"H"},
			{name:"19",chapter:"選出一件祈禱事項，特別留意天父給你的答案，並記錄下來。",q1:"A 我感謝天父答允了我的禱告",q2:"B 我在學習等待天父的回應",q3:"C 天父沒有答允我的禱告",q4:"D 天父把更好的東西賜給我",q5:"E 我的祈禱事項是",q6:"F",q7:"G",q8:"H"},
			{name:"20",chapter:"凡事謝恩，每天最少為一件事情感謝天父！",q1:"A 大部分日子做得到",q2:"B 未能做到",q3:"C 我會繼續去做",q4:"D 學習感恩，讓我更快樂",q5:"E 請寫下一件感恩的事情",q6:"F",q7:"G",q8:"H"},
			{name:"21",chapter:"邀請一位朋友和你一起返教會！",q1:"A 我沒有邀請朋友",q2:"B 我向朋友發出了邀請，但他沒答應",q3:"C 我成功邀請了朋友返教會",q4:"D 我會繼續去做",q5:"E 我沒有返教會，因為",q6:"F",q7:"G",q8:"H"},
			{name:"22",chapter:"每次吃飯前，先作感恩祈禱。",q1:"A 大部分日子做得到",q2:"B 未能做到",q3:"C 我會繼續去做",q4:"D 謝飯禱告，讓我更信靠神",q5:"E 我對拜偶像有些疑問，就是",q6:"F",q7:"G",q8:"H"},
			{name:"23",chapter:"主動欣賞別人，向身邊的人說出真誠讚賞他的話！",q1:"A 大部分日子做得到",q2:"B 未能做到",q3:"C 我會繼續去做",q4:"D 讚賞別人，讓我感受到愛",q5:"E 請你分享一句你曾讚賞人的話",q6:"F",q7:"G",q8:"H"},
			{name:"24",chapter:"細閱司務道、李愛銳或馬禮遜其中一位來華宣教士的事蹟。",q1:"A 我閱讀了",q2:"B 未能上網完成",q3:"C 我想知道更多宣教士的故事",q4:"D 我願意為宣教作準備",q5:"E 事蹟中令我感動的事情是",q6:"F",q7:"G",q8:"H"},
			{name:"25",chapter:"每天佩戴及使用全副軍裝！",q1:"A 佩戴了真理腰帶，返教會認識神",q2:"B 佩戴了公義護心鏡，不說謊話",q3:"C 佩戴了和平鞋子及救恩頭盔，為主作見證",q4:"D 舉起信心盾牌，每天禱告",q5:"E 握着聖靈寶劍，熟讀金句",q6:"F",q7:"G",q8:"H"},
			{name:"",chapter:"",q1:"",q2:"",q3:"",q4:"",q5:"",q6:"",q7:"",q8:""},
			{name:"學員",chapter:"栽培課",q1:"A",q2:"B",q3:"C",q4:"D",q5:"E",q6:"F",q7:"G",q8:"H"}
		)
		for(var index in this.viewMemApproval){
			//console.log(this.viewMemApproval[index].jRec.length)
			for (var jIndex in this.viewMemApproval[index].jRec){
				var ansNum = 1;
				var data = {
					name:"",chapter:jIndex,q1:"",q2:"",q3:"",q4:"",q5:"",q6:"",q7:"",q8:""
				}
				//if (jIndex == '1'){
					data.name=this.viewMemApproval[index].name
				//}
				for (var ansIndex in this.viewMemApproval[index].jRec[jIndex]){
					if (ansIndex=='created') continue
					if (this.viewMemApproval[index].jRec[jIndex][ansIndex]=='true'){
						data['q'+ansNum] = "y"
					} else if (this.viewMemApproval[index].jRec[jIndex][ansIndex]==''){
						data['q'+ansNum] = "n"
					} else {
						data['q'+ansNum] = this.viewMemApproval[index].jRec[jIndex][ansIndex]
					}
					ansNum++;
				}
				exportData.push(data)
			}			
			
		}
		//console.log(exportData);
		new Angular2Csv(exportData, new Date().toISOString());
	}

	selectCourse(selectedJourney){
		this.selectedJourney = selectedJourney;
		this.selectAllMem();
	}

	selectTab(tabNum:number){
		this.currTab = tabNum;
		if (tabNum == 1) this.selectAllMem();
	}


	toggleApprove(uid:String=''){
		if (uid=='') {
			this.allApproveSelected = !this.allApproveSelected
			if (this.allApproveSelected){
				for(let index in this.viewMemApproval){
					if ((this.viewMemApproval[index].lastFinished==this.viewMemApproval[index].nextJourney || this.viewMemApproval[index].nextJourney==0) && this.viewMemApproval[index].lastFinished<27){
						this.viewMemApproval[index].selected = true
					}
				}
			} else {
				for(let index in this.viewMemApproval){
					if ((this.viewMemApproval[index].lastFinished==this.viewMemApproval[index].nextJourney || this.viewMemApproval[index].nextJourney==0) && this.viewMemApproval[index].lastFinished<27){
						this.viewMemApproval[index].selected = false
					}
				}
			}
		} else {
			this.allApproveSelected = true
			for(let index in this.viewMemApproval){
				if ((this.viewMemApproval[index].lastFinished==this.viewMemApproval[index].nextJourney || this.viewMemApproval[index].nextJourney == 0) && this.viewMemApproval[index].lastFinished<27){
					if (this.viewMemApproval[index].uid==uid){
						this.viewMemApproval[index].selected = !this.viewMemApproval[index].selected
					}
					if (!this.viewMemApproval[index].selected) this.allApproveSelected = false
				}

			}
		}
	}

	selectAllMem() {
		this.viewMemApproval = [];
		let db = firebase.database();
		
		db.ref('journeyRecords').once('value').then(
			(snapshot:any) => {
				if (snapshot.val()){
					let allJRec = snapshot.val();
					//for (let uid in allJRec){
					//	console.log(allJRec[uid]);
					//}
					let memIndex = 0
					for(let mem of this.searchableMem){
						var lastFinished = 0
						var nextJ = 0
						var created = ''
						var jRec = {}
						var isApproved = 1
						if (Array.isArray(allJRec[mem.uid])) lastFinished = allJRec[mem.uid].length-1
						if (this.allProfile[mem.uid].nextJourney !== undefined) nextJ = this.allProfile[mem.uid].nextJourney.chapter
						if (allJRec[mem.uid] !== undefined) {
							if (allJRec[mem.uid][allJRec[mem.uid].length-1].created !== undefined) created = new Date(allJRec[mem.uid][allJRec[mem.uid].length-1].created).toISOString().slice(0,10)
							jRec = allJRec[mem.uid]
						}
						if ((lastFinished==nextJ || nextJ==0) && lastFinished<27 && lastFinished>0) isApproved = 0
						if (lastFinished<nextJ && lastFinished>0 && lastFinished<27) isApproved = 2
						this.viewMemApproval.push({
							selected:false,
							uid:mem.uid, 
							name:this.allProfile[mem.uid].name,
							group:this.allProfile[mem.uid].group,
							created:created, 
							lastFinished: lastFinished,
							nextJourney:nextJ,
							jRec:jRec,
							isApproved: isApproved,
							memIndex: memIndex
						});
						memIndex += 1
					}
				}
			}
		)

	}

	selectMem() {
		this.viewMem = [];
		for(let uid of this.selectedMem){
			var nextJ = 0
			if (this.allProfile[uid].nextJourney!=undefined) nextJ = this.allProfile[uid].nextJourney.chapter
			this.viewMem.push({uid:uid, name:this.allProfile[uid].name, nextJourney:nextJ});
		}
	}

	changeMem(){
		for(var studentUid of this.selectedMem){
			let db = firebase.database();
			db.ref('journeyRecords/'+studentUid).once('value').then(
				(snapshot:any) => {
					if (snapshot.val()){
						this.journeyRecs[studentUid] = snapshot.val().reverse();
						//get student feedback
						db.ref('memberMsg/'+studentUid).once('value').then(
							(snapshot:any)=>{
								if (snapshot.val()){
									var allInMsg = snapshot.val().in?snapshot.val().in:{};
									var allOutMsg = snapshot.val().out?snapshot.val().out:{};
									var allMsg = [];
									for(let msgId in allInMsg){
										if (allInMsg[msgId].type != '栽培回應') continue;
										db.ref('message/'+allInMsg[msgId].contentId).once('value').then(
											(snapshot:any)=>{
												this.contentMsg[allInMsg[msgId].contentId] = snapshot.val();
											}
										)
										let msgObj = {
											id:msgId, 
											msgBox: 'in',
											contentId:allInMsg[msgId].contentId,
											sendDate:allInMsg[msgId].sendDate, 
											sendFrom:allInMsg[msgId].sendFrom, 
											title:allInMsg[msgId].title, 
											type:allInMsg[msgId].type
										}
										allMsg.push(msgObj);
									}
									for(let msgId in allOutMsg){
										if (allOutMsg[msgId].type != '栽培回應') continue;
										db.ref('message/'+allOutMsg[msgId].contentId).once('value').then(
											(snapshot:any)=>{
												this.contentMsg[allOutMsg[msgId].contentId] = snapshot.val();
											}
										)
										let msgObj = {
											id:msgId, 
											msgBox: 'out',
											contentId:allOutMsg[msgId].contentId,
											sendDate:allOutMsg[msgId].sendDate, 
											sendTo:allOutMsg[msgId].sendTo, 
											title:allOutMsg[msgId].title, 
											type:allOutMsg[msgId].type
										}
										allMsg.push(msgObj);
									}

									allMsg.sort(this._dateSort);
									//_.sortBy(allMsg, 'sendDate');
									this.journeyRecs[studentUid].reply = [];
									for(var i=1; i<this.journeyRecs[studentUid].length; i++){
										var searchStr = '栽培第'+i+'課';
										this.journeyRecs[studentUid].reply[i] = [];
										_.each(allMsg, (msg)=>{
											if (msg.title.indexOf(searchStr) != -1) this.journeyRecs[studentUid].reply[i].push(msg);
										})
									}
								}
							}
						)
					} else {
						this.journeyRecs[studentUid] = [];
					}
				}
			);
		}
	}
	
	_dateSort(a, b){
		var dateA = new Date(a.sendDate).getTime();
		var dateB = new Date(b.sendDate).getTime();
		return dateA < dateB ? 1 : -1;  
	}

	generateArray(obj){
		return Object.keys(obj).map((key)=>{ 
			if (key=='created') {
				delete obj[key]
				return
			}
			return obj[key]
		});
	}

	showAll(uid:string){
		if(this.detailMem==uid){
			this.detailMem = '';
		} else {
			this.detailMem = uid;
		}
	}

	showQA(chapter:number){
		this.qaImg = chapter;
	}

	showReply(uid:string, chapter:number){
		if (this.replyNum == uid+chapter){
			this.replyNum = '';
		} else {
			this.replyNum = uid+chapter;
		}
	}

	reply(uid:string, chapter:number){
		this.msgTo = uid;
		this.msgTitle = '回應栽培第'+chapter+'課';
	}

	confirmReply(fromInternal:boolean=false){
		if (!fromInternal) this.msgContent = tinymce.activeEditor.getContent();	
		if (this.msgContent == '' || this.msgTitle == '' || this.msgTo==''){
			this.warningMsg = '請選擇接收訊息會員，輸入內容及標題！';
			setTimeout(()=>{this.warningMsg = '';},this.memberService.modalDismiss);
			return;
		}

		
		let db = firebase.database();
		db.ref('message/').push({content: this.msgContent}).then(
			(val:any)=>{
				var contentUid = val.key;
				db.ref('memberMsg/'+this.currUser.uid+'/out').push(
					{
						title:this.msgTitle,
						type:'栽培回應',
						contentId:contentUid,
						sendDate:(new Date()).toString(),
						sendTo:[this.msgTo]
					}
				).then(
					(val:any) => {
						db.ref('memberMsg/'+this.msgTo+'/in').push(
							{
								title:this.msgTitle,
								type:'栽培回應',
								contentId:contentUid,
								sendDate:(new Date()).toString(),
								sendFrom:this.currUser.uid
							}
						)
						this.selectMem();
						this.changeMem();
						this.replyNum = '';
						this.warningMsg = '訊息已發送！';
						setTimeout(()=>{
							this.warningMsg = '';
							this.msgTitle = '';
							this.msgTo = '';
						},this.memberService.modalDismiss);
					}
					
				)
			}
		)
	}

	batchApproveNext(){
		let db = firebase.database()
		for(let index in this.viewMemApproval){
			if ((this.viewMemApproval[index].lastFinished==this.viewMemApproval[index].nextJourney || this.viewMemApproval[index].nextJourney==0) && this.viewMemApproval[index].lastFinished<27){
				if (this.viewMemApproval[index].selected){
					var nextJ = this.viewMemApproval[index].lastFinished+1
					var approveDate = new Date(this.approvalDate).toDateString()

					db.ref('profile/'+this.viewMemApproval[index].uid+'/nextJourney').set({chapter:nextJ,validDate:approveDate}).then(
						(val:any) => {
							this.msgContent = '如題';
							let nextTime = new Date(approveDate).toISOString().slice(0,10);
							this.msgTitle = '你已批准於'+nextTime+'或之後進行第'+nextJ+'栽培課';
							this.msgTo = this.viewMemApproval[index].uid;
							this.confirmReply(true);

							this.http.get(this.memberService.EBURL+"getMemberInfo/"+this.viewMemApproval[index].uid+"/1").subscribe((res:any)=> {
								res = res.json()
								//if (res.emailVerified) {
									this.memberService.sendApproveMail("websys@lovekid.hk", res.email, this.allProfile[this.viewMemApproval[index].uid].name, nextTime)
								//}
							});
						}
					)
					this.allProfile[this.viewMemApproval[index].uid].nextJourney = {chapter:nextJ,validDate:approveDate}
					this.searchableMem[this.viewMemApproval[index].memIndex].nextJourney = {chapter:nextJ,validDate:approveDate}
					this.viewMemApproval[index].nextJourney = nextJ
				}
			}
		}
	}

	approveNext(uid:string, nextJourney:number, approveDate:string=new Date().toDateString()){
		let db = firebase.database();
		if (uid && nextJourney){
			db.ref('profile/'+uid+'/nextJourney').set({chapter:nextJourney,validDate:approveDate}).then(
				(val:any) => {
					for(let i in this.viewMem){
						if (this.viewMem[i].uid==uid){
							this.viewMem[i].nextJourney = nextJourney;
							this.msgContent = '如題';
							let nextTime = new Date(approveDate).toISOString().slice(0,10);
							this.msgTitle = '你已批准於'+nextTime+'或之後進行第'+nextJourney+'栽培課';
							this.msgTo = uid;
							this.confirmReply(true);

							this.http.get(this.memberService.EBURL+"getMemberInfo/"+uid+"/1").subscribe((res:any)=> {
								res = res.json()
								//if (res.emailVerified) {
									this.memberService.sendApproveMail("websys@lovekid.hk", res.email, this.allProfile[uid].name, nextTime)
								//}
							});
							break
						}
					}
				}
			)
		}
	}
}



// WEBPACK FOOTER //
// C:/Users/noomo/Desktop/project/newCefKid/cefapp2/src/app/webadmin/journey.component.ts